<template lang="pug">
div.small-margin
  b-field(:label="initBlock.config.label" label-position="on-border" :maxlength="initBlock.config.maxlength")
    b-input(:value="initBlock.value.text" @input="updateValue")
</template>

<script>
export default {
  components: {

  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            text: null
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    updateValue(e) {
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          text: e
        }
      });
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.small-margin {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>